const currentWindowOrigin = window.location.origin

export default {
    REGION: 'eu-west-1',
    USER_POOL_ID: 'eu-west-1_gdB8gZXDC',
    USER_POOL_APP_CLIENT_ID: '7cl327frcfrec0aj07ou8n2o87',
    REDIRECT_SIGN_IN: currentWindowOrigin,
    DOMAIN: 'admin-central-staging.auth.eu-west-1.amazoncognito.com',
}
